import React, {FC, useState} from 'react';
import { useForm } from 'react-hook-form';



export type PaymentFormData = {
    amount: number,
    description: string,
    currency: string,    
};

type IPaymentFormProps = {
    type: 'create' | 'update',
    defaultFormData: PaymentFormData,
    onSubmit: (data: PaymentFormData) => void
};


const PaymentAdminForm: FC<IPaymentFormProps> = ({type, defaultFormData, onSubmit}) => {
    const { register, handleSubmit, setValue } = useForm<PaymentFormData>({defaultValues: defaultFormData});

    // evt handlers
    const onFormSubmit = (formData: PaymentFormData) => {
        // validation
        const isNotEmpty =  Object.values(formData).every(value => value !== undefined && value !== '');        
        if (!isNotEmpty || isNaN(formData.amount)) {
            return console.log('Error, incorrect type / empty fields!', formData);
        }
        // console.log('Form data is: ', formData);
        onSubmit(formData);
        
    };

    return <section
        id="form-section"
        className="w-full flex flex-col mr-3 my-3 rounded-xl p-4 shadow-lg bg-white dark:bg-gray-900">
        <form 
            onSubmit={handleSubmit(onFormSubmit)}
            className="w-full flex flex-col mb-6">
            {/* First Row */}
            <div className="w-full px-3 mb-6 md:mb-0">
                <label
                    className="block uppercase tracking-wide text-gray-700 dark:text-teal-400 text-xs font-bold mb-2"
                    htmlFor="form-amount">
                    Payment Amount*
                </label>
                <input
                    {...register('amount')}
                    className="appearance-none block w-full md:w-1/2 lg:w-1/3 border-2 border-blue-200 dark:border-teal-700 bg-gray-200 text-gray-700 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="form-amount"
                    type="text"
                    placeholder="50.00"/>
                <p className="hidden text-red-500 text-xs italic">Required</p>
            </div>
            {/* Second Row */}
            <div className="w-full px-3">
                <label
                    className="block uppercase tracking-wide text-gray-700 dark:text-teal-400 text-xs font-bold mb-2"
                    htmlFor="form-description">
                    Description*
                </label>
                <textarea
                    {...register('description')}
                    id="form-description"
                    rows={4}
                    cols={10}
                    className="appearance-none block w-full border-2 border-blue-200 dark:border-teal-700 bg-gray-200 text-gray-700 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    placeholder="Description of the payment breakdown..."/>
            </div>
            {/* Third Row */}                    
            <div className="w-full md:w-1/3 px-3 mb-6">
                <label
                    className="block uppercase tracking-wide text-gray-700 dark:text-teal-400  text-xs font-bold mb-2"
                    htmlFor="grid-state">
                    Currency*
                </label>
                <div className="relative">
                    <select
                        {...register('currency')}
                        className="block appearance-none w-full border-2 border-blue-200 dark:border-teal-700 bg-gray-200 border border-gray-200 text-gray-700  py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                        id="grid-state">
                        <option value="usd">US Dollars</option>
                        {/* <option value="inr">Indian Ruppee</option> */}
                        {/* <option value="myr">Malaysian Ringgits</option> */}
                    </select>
                    <div
                        className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg
                            className="fill-current h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"><path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                </div>
            </div>            
            {/* Submit button */}
            <div className="w-full flex">
            <button
                type='submit'                            
                className="my-6 mx-3 bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 border-b-4 border-blue-700 hover:border-blue-500 rounded">
                {type === 'create' ? 'Create Payment' : 'Update Payment'}
            </button>
            <button
                type='reset'
                className="my-6 mx-3 bg-gray-300 hover:bg-gray-400 text-gray-700 hover:text-white font-bold py-2 px-4 border-b-4 border-gray-500 hover:border-gray-700 rounded">
                Cancel
            </button>
            </div>
        </form>
    </section>
};

export default PaymentAdminForm;